import React from 'react';
import NoIdHomepage from './NoIdHomepage';

const NoIdHomepageContainer = () => {
  return <NoIdHomepage />;
};

export default NoIdHomepageContainer;
